import { put, takeLatest } from "redux-saga/effects";

import {
  UPDATE_FIRST_LOGIN_FAILURE,
  UPDATE_FIRST_LOGIN_REQUEST,
  UPDATE_FIRST_LOGIN_SUCCESS,
} from "../../../modules/constants";
import { defaultApi } from "../../../utils/axiosApi";

function* updateFirstLoginSaga({ payload }) {
  try {
    const response = yield defaultApi(
      "/onboarding/first-login/",
      "POST",
      payload,
    );
    yield put({ type: UPDATE_FIRST_LOGIN_SUCCESS, payload: response });

    if (response.status === 200 && response.data) {
      if (response.data.first_login !== undefined) {
        localStorage.setItem(
          "is_first_login",
          response.data.first_login.toString(),
        );
      }
    }
  } catch (error) {
    yield put({ type: UPDATE_FIRST_LOGIN_FAILURE, error });
  }
}

export default function* onboardingWatcher() {
  yield takeLatest(UPDATE_FIRST_LOGIN_REQUEST, updateFirstLoginSaga);
}
